import { isCompletedTask } from "./ProbateMessages";

const isOpen = (doable) => doable.status === "available";

// The backend stores request_group_collections as the staff app sends it, so it may not be a list
export const collectionsOf = (selectedCase) =>
  Array.isArray(selectedCase.request_group_collections) ? selectedCase.request_group_collections : [];

export const isDone = isCompletedTask;

export const doableStatus = (doable) => {
  if (isDone(doable)) {
    return "done";
  }
  return doable.has_draft ? "in_progress" : "not_started";
};

export const collectionStatus = (doables) => {
  const statuses = doables.map(doableStatus);
  if (statuses.every((status) => status === "done")) {
    return "done";
  }
  return statuses.some((status) => status !== "not_started") ? "in_progress" : "not_started";
};

export const collectionPath = (caseRef, collection) => `/dashboard/${caseRef}/to-do/${collection.identifier}`;

// A collection shows its open and done requests; a doable in any other status has nothing for the client to do or see
export const collectionDoables = (collection, doables) =>
  doables.filter((d) => d.request_group_collection?.identifier === collection.identifier && (isOpen(d) || isDone(d)));

export const openCollections = (collections, doables) =>
  collections
    .map((collection) => ({ ...collection, doables: collectionDoables(collection, doables) }))
    .filter((collection) => collection.doables.some(isOpen));

export const openDoablesWithoutCollection = (collections, doables) =>
  doables.filter(
    (d) =>
      isOpen(d) && !collections.some((collection) => collection.identifier === d.request_group_collection?.identifier),
  );

const positionOf = (doable) => doable.request_group_collection?.position;
const hasPosition = (doable) => positionOf(doable) != null;

// Doables synced before the staff app sent a position have none, so they
// follow the positioned ones in the order they were raised.
const byPositionInCollection = (a, b) =>
  hasPosition(b) - hasPosition(a) ||
  (hasPosition(a) ? positionOf(a) - positionOf(b) : new Date(a.created_at) - new Date(b.created_at));

const untitledSection = { identifier: "", title: "" };

export const collectionSections = (collection, doables) => {
  const sections = collection.sections?.length ? collection.sections : [untitledSection];
  const identifiers = sections.map((section) => section.identifier);
  const sectionOf = (doable) => {
    const section = doable.request_group_collection?.section;
    return identifiers.includes(section) ? section : identifiers[identifiers.length - 1];
  };
  const sorted = [...doables].sort(byPositionInCollection);
  return sections.map((section) => ({
    ...section,
    doables: sorted.filter((doable) => sectionOf(doable) === section.identifier),
  }));
};
